
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { NRCandidate, NREducation, NRWork } from "@/lib/model/NRXQ/candidate";
import dayjs from "dayjs";
import { NRClientType, AtsCompany, CV } from "@/lib/model/NRXQ/nr";
import { ExamInfo } from "@/lib/model/exam/candidate";
import request from "@/lib/request/request";
import config from "@/config/config";
import NRProjectEdit from "@/views/nr/components/nr-project-edit.vue";
import NRAttachmentEdit from "@/views/nr/components/nr-attachment-edit.vue";
import UploadCv from "@/views/nr/components/upload-cv.vue";
import { ElForm } from "element-ui/types/form";

@Component({ components: { NRProjectEdit, NRAttachmentEdit, UploadCv } })
export default class AtsCV extends Vue {
  @Prop({ type: NRCandidate, default: 0 }) cv!: NRCandidate;
  @Prop({ type: String, default: NRClientType.NRClientTypeAdmin })
  clientType = NRClientType.NRClientTypeAdmin;
  topHeight = 0;

  getH() {
    this.$nextTick(() => {
      setTimeout(() => {
        const dom = this.$refs.showLimit as any;
        console.log("PC send");

        this.$emit("setTopHeight", dom.offsetTop);
      }, 1);
    });
  }

  edit = false; // 编辑简历状态
  atsCompanyList?: AtsCompany[] = [];

  selectedStatus = "";

  companyName(companyId: any) {
    if (this.atsCompanyList) {
      for (const item of this.atsCompanyList) {
        if (item.atsCompanyId == companyId) {
          return item.name;
        }
      }
    }
    return "";
  }

  getFormatMonth(date: any) {
    return dayjs(date).format("YYYY-MM");
  }
}
